import React, { Component } from 'react'
import ReactExport from "react-export-excel";
import { Row } from 'react-bootstrap';
import CanvasJSReact from '../../canvasjs.react';
import Firebase from '../Firebase';
import Qestions from './Questions.json';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
export class SsrResult extends Component {
    render() {
        return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div className="data_center">
                    <p style={{ textAlign: 'center', fontSize: 26 }}>
                        <strong>
                            แบบสอบถาม
                        <br></br>
                        ประเมินผลโครงการการพัฒนาพื้นที่ครอบครัวอบอุ่นต้นแบบ
                        <br></br>
                        ที่เชื่อมโยงและบูรณาการกับระบบและกลไกการดูแลระดับพื้นที่
                    </strong>
                    </p>
                    <br></br>
                    <hr></hr>
                    <Data></Data>
                    <div>
                        <p>ติดต่อผู้พัฒนา email:adison.ra.56@ubu.ac.th  line-ID:oqiew2537</p>
                        <p>โทรศัพท์:0933807540 นายอดิศร ราชชิต</p>
                    </div>
                </div>
            </div>
        )
    }
}
export class Data extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            gdata: [],
            tquestion: this.gettq(),
            counta: 0,
            // graph
            sSex: '',
            sAge: '',
            sRole: '',
            options: [],
            mainOptions: []
        }

    }
    componentDidMount() {
        Firebase.firestore().collection('SSUREE').onSnapshot(this.getData);
    }
    getData = (querySnapshot) => {
        var gn = 513 * 5;
        var n = querySnapshot.size;
        const data = [];
        const sSex = [0, 0];
        const sAge = [0, 0, 0, 0, 0];
        const sRole = [0, 0, 0];
        const options = [];
        const mainOptions = [];
        var sumex = 0;
        var sumexav2 = 0;
        var sumdata = [0, 0, 0, 0, 0, 0];
        // นับ count ของ คะแนน 12345
        // ข้อมูลช่องคะแนน
        const data_st = [[0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0]
            , [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0],
        [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0], [0, 0, 0, 0, 0, 0]];
        //22
        querySnapshot.forEach((doc, i) => {
            const { Answer, Sex, Age, Role, Create_date, Suggestion } = doc.data();

            const Answer1 = Answer[0];
            const Answer2 = Answer[1];
            const Answer3 = Answer[2];
            const Answer4 = Answer[3];
            const Answer5 = Answer[4];
            const Answer6 = Answer[5];
            const Answer7 = Answer[6];
            const Answer8 = Answer[7];
            const Answer9 = Answer[8];
            const Answer10 = Answer[9];
            const Answer11 = Answer[10];
            const Answer12 = Answer[11];
            const Answer13 = Answer[12];
            const Answer14 = Answer[13];
            const Answer15 = Answer[14];
            const Answer16 = Answer[15];
            const Answer17 = Answer[16];
            const Answer18 = Answer[17];
            const Answer19 = Answer[18];
            const Answer20 = Answer[19];
            const Answer21 = Answer[20];
            const Answer22 = Answer[21];
            data.push({
                ...doc.data(), CreateDate: new Date(Create_date.seconds * 1000),
                Answer1,
                Answer2,
                Answer3,
                Answer4,
                Answer5,
                Answer6,
                Answer7,
                Answer8,
                Answer9,
                Answer10,
                Answer11,
                Answer12,
                Answer13,
                Answer14,
                Answer15,
                Answer16,
                Answer17,
                Answer18,
                Answer19,
                Answer20,
                Answer21,
                Answer22
            });
            if (Sex === 'ชาย') {
                sSex[0] += 1;
            } else {
                sSex[1] += 1;
            }
            if (Age === 'ต่ำกว่า 20 ปี') {
                sAge[0] += 1;
            } else if (Age === '20-30 ปี') {
                sAge[1] += 1;
            } else if (Age === '31-40 ปี') {
                sAge[2] += 1;
            } else if (Age === '41-50 ปี') {
                sAge[3] += 1;
            } else {
                sAge[4] += 1;
            }
            if (Role === 'ผู้เข้าร่วมโครงการ') {
                sRole[0] += 1;
            } else if (Role === 'แกนนำโครงการ') {
                sRole[1] += 1;
            } else {
                sRole[2] += 1;
            }
            for (let index = 0; index < data_st.length; index++) {
                // console.log("ข้อที่",index,"ตอบ",Answer2[index])
                // เก็บค่าข้อมูล เพื่อนำไปนับ
                data_st[index][parseInt(Answer[index], 10)] += 1;
            }

        })
        data_st.forEach((d, j) => {
            //บวกจำนวนของแต่ละข้อ
            var ex = (parseInt(d[5], 10) * 5) + (parseInt(d[4], 10) * 4) + (parseInt(d[3], 10) * 3) + (parseInt(d[2], 10) * 2) + (parseInt(d[1], 10) * 1);
            sumex += ex;
            sumdata[5] += parseInt(d[5], 10);
            sumdata[4] += parseInt(d[4], 10);
            sumdata[3] += parseInt(d[3], 10);
            sumdata[2] += parseInt(d[2], 10);
            sumdata[1] += parseInt(d[1], 10);
            // var ex22 = Math.pow(ex, 2);

            var av = ex / n;
            var exav2 = (parseInt(d[5], 10) * Math.pow((5 - av), 2)) + (parseInt(d[4], 10) * Math.pow((4 - av), 2)) +
                (parseInt(d[3], 10) * Math.pow((3 - av), 2)) + (parseInt(d[2], 10) * Math.pow((2 - av), 2)) + (parseInt(d[1], 10) * Math.pow((1 - av), 2));
            // console.log("ข้อที่ " + (j + 1) + "ค่าเฉลี่ย " + (av));
            // console.log(parseInt(d[5], 10), Math.pow((5 - av), 2))
            sumexav2 += exav2;
            var std = Math.sqrt(exav2 / (n - 1));
            options.push({
                gdata: {
                    animationEnabled: true,
                    exportEnabled: true,
                    theme: "light1", // "light1", "dark1", "dark2"
                    title: {
                        text: (j + 1) + "." + this.state.tquestion[j],
                        fontSize: 20
                    },
                    data: [{
                        type: "pie",
                        indexLabel: "{label}: {y}%",
                        // startAngle: -10 ,
                        dataPoints: [
                            { y: (parseInt(d[5], 10) * 100 / querySnapshot.size).toFixed(2), label: 'มากที่สุด' },
                            { y: (parseInt(d[4], 10) * 100 / querySnapshot.size).toFixed(2), label: 'มาก' },
                            { y: (parseInt(d[3], 10) * 100 / querySnapshot.size).toFixed(2), label: 'พอใช้' },
                            { y: (parseInt(d[2], 10) * 100 / querySnapshot.size).toFixed(2), label: 'น้อย' },
                            { y: (parseInt(d[1], 10) * 100 / querySnapshot.size).toFixed(2), label: 'น้อยที่สุด' }
                        ]
                    }]
                },
                data: {
                    av: av.toFixed(2),
                    std: std.toFixed(2),
                    sum: d,
                }



            })
        })
        var countmain = querySnapshot.size * 22;
        mainOptions.push({
            gdata: {
                animationEnabled: true,
                exportEnabled: true,
                theme: "light1", // "light1", "dark1", "dark2"
                title: {
                    text: "สรุปผลรวมทั้งหมด",
                    fontSize: 20
                },
                data: [{
                    type: "pie",
                    indexLabel: "{label}: {y}%",
                    // startAngle: -10 ,
                    dataPoints: [
                        { y: (sumdata[5] * 100 / countmain).toFixed(2), label: 'มากที่สุด' },
                        { y: (sumdata[4] * 100 / countmain).toFixed(2), label: 'มาก' },
                        { y: (sumdata[3] * 100 / countmain).toFixed(2), label: 'พอใช้' },
                        { y: (sumdata[2] * 100 / countmain).toFixed(2), label: 'น้อย' },
                        { y: (sumdata[1] * 100 / countmain).toFixed(2), label: 'น้อยที่สุด' }
                    ]
                }]
            },
            data: {
                av: (sumex / countmain).toFixed(2),
                std: (Math.sqrt(sumexav2 / (countmain - 1))).toFixed(2),
                sum: sumdata,
            }
        })
        console.log(mainOptions)
        this.setState({
            sSex, sAge, sRole,
            counta: querySnapshot.size,
            options,
            data,
            mainOptions
        })
    }
    gettq() {
        const tquestion = [];
        Qestions.Q1.forEach((doc, i) => {
            if (i === 3) {
                doc.question.forEach((doc2, i2) => {

                    if (i2 === 0) {
                        doc2.subq.forEach((doc3, i3) => {
                            tquestion.push(
                                doc3
                            )
                        })
                    } else if (i2 === 1) {
                        doc2.subq.forEach((doc3, i3) => {
                            tquestion.push(
                                doc3
                            )
                        })
                    }
                })
            } else {
                doc.question.forEach((doc2, i2) => {
                    tquestion.push(
                        doc2
                    )
                })
            }

        })
        return tquestion

    }

    render() {
        const { sSex, sAge, sRole, counta } = this.state;
        const { mainOptions } = this.state;
        const optionsSex = {
            animationEnabled: true,
            exportEnabled: true,
            theme: "light1", // "light1", "dark1", "dark2"
            title: {
                text: "เพศ ชาย " + sSex[0] + "คน หญิง " + sSex[1] + "คน",
                fontSize: 20
            },
            data: [{
                type: "pie",
                indexLabel: "{label}: {y}%",
                // startAngle: -10 ,
                dataPoints: [
                    { y: (sSex[0] * 100 / counta).toFixed(2), label: 'ชาย' },
                    { y: (sSex[1] * 100 / counta).toFixed(2), label: 'หญิง' },
                ]
            }]
        }
        const optionsAge = {
            animationEnabled: true,
            exportEnabled: true,
            theme: "light1", // "light1", "dark1", "dark2"
            title: {
                text: 'อายุ ต่ำกว่า 20 ปี ' + sAge[0] + "คน 20-30 ปี " + sAge[1] + "คน 31-40 ปี " + sAge[2] + "คน 41-50 ปี " + sAge[3] + "คน 51 ปีขึ้นไป " + sAge[4] + "คน",
                fontSize: 20
            },
            data: [{
                type: "pie",
                indexLabel: "{label}: {y}%",
                // startAngle: -10 ,
                dataPoints: [
                    { y: (sAge[0] * 100 / counta).toFixed(2), label: 'ต่ำกว่า 20 ปี' },
                    { y: (sAge[1] * 100 / counta).toFixed(2), label: '20-30 ปี' },
                    { y: (sAge[2] * 100 / counta).toFixed(2), label: '31-40 ปี' },
                    { y: (sAge[3] * 100 / counta).toFixed(2), label: '41-50 ปี' },
                    { y: (sAge[4] * 100 / counta).toFixed(2), label: '51 ปีขึ้นไป' },
                ]
            }]
        }
        const optionsRole = {
            animationEnabled: true,
            exportEnabled: true,
            theme: "light1", // "light1", "dark1", "dark2"
            title: {
                text: 'บทบาทในการดำเนินโครงการของผู้ตอบแบบสอบถาม ผู้เข้าร่วมโครงการ' + sRole[0] + "คน แกนนำโครงการ " + sRole[1] + "คน อื่น ๆ " + sRole[2] + "คน",
                fontSize: 20
            },
            data: [{
                type: "pie",
                indexLabel: "{label}: {y}%",
                // startAngle: -10 ,
                dataPoints: [
                    { y: (sRole[0] * 100 / counta).toFixed(2), label: 'ผู้เข้าร่วมโครงการ' },
                    { y: (sRole[1] * 100 / counta).toFixed(2), label: 'แกนนำโครงการ' },
                    { y: (sRole[2] * 100 / counta).toFixed(2), label: 'อื่น ๆ' },

                ]
            }]
        }

        return (
            <div style={{ justifyContent: 'center' }}>
                <Row>
                    <p style={{ margin: 5 }}>ดาวน์โหลดเอกสาร excel</p>
                    <ExcelFile element={<button style={{ borderRadius: 10, margin: 5 }}>ดาวน์โหลด</button>}>

                        <ExcelSheet data={this.state.data} name="นักเรียน" >
                            <ExcelColumn label="เพศ" value="Sex" />
                            <ExcelColumn label="อายุ" value="Age" />
                            <ExcelColumn label="บทบาทในการดำเนินโครงการของผู้ตอบแบบสอบถาม" value="Role" />
                            {this.state.tquestion.map((element, i) =>
                                <ExcelColumn key={i} label={"no" + (i + 1)} value={"Answer" + (i + 1)} />
                            )}
                            <ExcelColumn label="ข้อเสนอแนะ" value="Suggestion" />
                            <ExcelColumn label="วันที่" value="CreateDate" />


                        </ExcelSheet>
                    </ExcelFile>
                </Row>
                <div style={{ marginLeft: '3%' }}>
                    <div style={{ justifyContent: 'center' }}>
                        <p style={{ fontSize: 20, textAlign: 'center' }}><strong>จำนวนการตอบแบบสอบถาม {this.state.counta}</strong></p>

                    </div>
                    <Row>
                        <div style={{ width: '50%' }}>
                            <CanvasJSChart options={optionsSex} />
                        </div>
                        <div style={{ width: '50%' }}>
                            <CanvasJSChart options={optionsAge} />
                        </div>
                    </Row>
                    <Row>
                        <div style={{ width: '50%' }}>
                            <CanvasJSChart options={optionsRole} />
                        </div>

                    </Row>

                    <div style={{ justifyContent: 'center' }}>
                        <p style={{ fontSize: 20, textAlign: 'center' }}><strong>ส่วนที่ 2 : การประเมินผลการดำเนินโครงการการพัฒนาพื้นที่ครอบครัวอบอุ่นต้นแบบที่เชื่อมโยง
                            และบูรณาการกับระบบและกลไกการดูแลระดับพื้นที่</strong></p>
                        {mainOptions.map((element) =>
                            <Row key={0}>
                                <div style={{ width: '50%', }}>
                                    <CanvasJSChart options={element.gdata} />
                                </div>
                                <div style={{ width: '50%', marginTop: 20 }}>
                                    <p>ส่วนเบี่ยงเบนมาตรฐาน :  {element.data.std}</p>
                                    <p>ค่าเฉลี่ย : {element.data.av}</p>
                                    {/* <p>มากที่สุด จำนวน : {element.data.sum[5]} </p>
                                    <p>มาก จำนวน : {element.data.sum[4]} </p>
                                    <p>พอใช้ จำนวน : {element.data.sum[3]} </p>
                                    <p>น้อย จำนวน : {element.data.sum[2]} </p>
                                    <p>น้อยที่สุด จำนวน : {element.data.sum[1]} </p> */}
                                </div>
                            </Row>
                        )}
                        {this.state.options.map((element, i) =>
                            <Row key={i}>
                                <div style={{ width: '50%', }}>
                                    <CanvasJSChart options={element.gdata} />
                                </div>
                                <div style={{ width: '50%', marginTop: 20 }}>
                                    <p>ส่วนเบี่ยงเบนมาตรฐาน :  {element.data.std}</p>
                                    <p>ค่าเฉลี่ย : {element.data.av}</p>
                                    <p>มากที่สุด จำนวน : {element.data.sum[5]} คน</p>
                                    <p>มาก จำนวน : {element.data.sum[4]} คน</p>
                                    <p>พอใช้ จำนวน : {element.data.sum[3]} คน</p>
                                    <p>น้อย จำนวน : {element.data.sum[2]} คน</p>
                                    <p>น้อยที่สุด จำนวน : {element.data.sum[1]} คน</p>
                                </div>
                            </Row>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}
export default SsrResult
